import React, { useState, useEffect } from 'react';
import api from '../../../services/api';
import { Box, FormGroup, Modal, Skeleton, TextareaAutosize } from '@mui/material';
import { Autocomplete, TextField } from '@mui/material';
import { Button, Col, Row } from 'react-bootstrap';
import { Label } from '../../../components/Label';
import { CardContent } from '../../../components/CardContent';
import { AtentoPGR } from '../../../components/ModDocPGR/AtentoPGR';
import { Options, Select } from '../../../components/Select';
import { useLocation } from 'react-router-dom';
import './style.css';
import NotInterestedIcon from '@mui/icons-material/NotInterested';
import { NiveisAcesso } from '../../../constants/niveisAcesso';
import AlertMessage from '../../../components/Alert';

export function PgrGerarDocumento({ idEmpresa, idFdt, idRevisao, idGhe, funcoes, selectedEmissaoId, documento, externoPgr, externoPcmso, enviado }: any) {
    const [responsaveis, setResponsaveis] = useState([]);
    const [responsavelSelecionado, setResponsavelSelecionado] = useState(null);
    const [responsavelRelacionado, setResponsavelRelacionado]: any = useState(null);
    const [idResponsavel, setResponsavelId] = useState(null);
    const [nivelAcesso, setNivelAcesso] = useState(0);
    const [showReturnModal, setShowReturnModal] = useState(false)
    const [observacao, setObservacao]: any = useState()
    const [alert, setAlert] = useState({ show: false, message: '', variant: 'success' });

    const [teste, setTeste] = useState(true);

    const location = useLocation();
    const pathName = location.pathname;
    const routeName = pathName.substring(pathName.lastIndexOf('/') + 1).toUpperCase();

    useEffect(() => {
        const fetchResponsaveis = async () => {
            try {
                const responseResponsaveis = await api.get('listar-responsaveis');
                setResponsaveis(responseResponsaveis.data);

                const responseResponsavelEmpresa = await api.get(`listar-responsavel-por-empresa/${idEmpresa}`);
                setResponsavelSelecionado(responseResponsavelEmpresa.data[0].id);
            } catch (error) {
                console.error('Erro ao buscar responsáveis', error);
            }

        };

        fetchResponsaveis();
    }, [idEmpresa]);

    useEffect(() => {
        api.get('nivel-acesso').then((response: any) => {
            setNivelAcesso(response.data.nivel)
        })
    }, [idEmpresa, idFdt, idRevisao])

    const handleSelectResponsavel = (id: any) => {
        setResponsavelSelecionado(id);
    };

    const handleCloseReturnModal = () => {
        setShowReturnModal(false)
        setObservacao('')
    }

    const getExternoBasedOnRoute = () => {
        if (routeName === 'PGR') {
            return externoPgr;
        } else if (routeName === 'PCMSO') {
            return externoPcmso;
        }
        return null;
    };

    const handleReturnDocumento = async () => {
        try {
          const payload = {
            id_empresa: idEmpresa,
            id_fdt: idFdt,
            id_revisao: idRevisao,
            observacao: observacao
          };
      
          const response = await api.post('doc/retornar-documento-empresa', payload);
      
          if (response.status === 200) {
            setAlert({ message: 'Documento retornado para a empresa!', variant: 'success', show: true });
            setObservacao(''); 
            handleCloseReturnModal(); 
          } else {
            setAlert({ message: 'Erro ao retornar documento!', variant: 'danger', show: true });
          }
        } catch (error) {
          console.error(error);
          setAlert({ message: 'Erro ao tentar retornar documento.', variant: 'danger', show: true });
        }
      };

    const externo = getExternoBasedOnRoute();

    return (
        <div className='py-4'>
            {/* {externo ? (
                <div style={{ position: 'relative', width: '100%' }}>
                    <Skeleton variant="rectangular" width="100%" height={200} animation="wave" style={{ backgroundColor: '#E6E6E6', borderRadius: '10px' }} />
                    <div style={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: '100%',
                        textAlign: 'center',
                        color: 'gray',
                        fontSize: '20px',
                        fontWeight: 'bold'
                    }}>

                        Para mais funcionalidades, adquira uma revisão ou inicie uma nova frente de trabalho.
                    </div>
                </div>

            ) : ( */}
                <CardContent className="my-4">
                    <Row className='my-4'>
                        <Col md={4}>
                            <FormGroup className='form-group-dsg'>
                                <Label title="RESPONSÁVEL" htmlFor="resp" />
                                {documento === "PGR" && (
                                    <>
                                        <Select id="selectResponsavel" onSelect={handleSelectResponsavel}>
                                            {responsaveis && responsaveis.map((responsavel: any) => (
                                                <Options
                                                    key={responsavel.id}
                                                    value={responsavel.id}
                                                    name={responsavel.nome}
                                                    selected={responsavel.id == responsavelSelecionado}
                                                />
                                            ))}
                                        </Select>
                                    </>
                                )}
                                {documento === "PCMSO" && (
                                    <>
                                        Maurício Cheratzki
                                    </>
                                )}

                            </FormGroup>
                            {nivelAcesso == NiveisAcesso.ADMIN && (
                                <Button className='pgr-return-button mt-4' onClick={() => setShowReturnModal(true)} >
                                    <NotInterestedIcon style={{ marginRight: '10px' }} />
                                    Retornar Documento
                                </Button>
                            )}
                        </Col>
                        <Col md={8} className='d-flex justify-content-end'>
                            <AtentoPGR
                                idEmpresa={idEmpresa}
                                idFdt={idFdt}
                                idRevisao={idRevisao}
                                idGhe={idGhe}
                                responsavel={responsavelSelecionado}
                                funcoes={funcoes}
                                selectedEmissaoId={selectedEmissaoId}
                                documento={documento}
                                externoPgr={externoPgr}
                                externoPcmso={externoPcmso}
                                enviado={enviado}
                            />
                        </Col>
                    </Row>
                    <Modal
                        open={showReturnModal}
                        onClose={handleCloseReturnModal}
                        style={{ backdropFilter: 'blur(10px)' }}
                    >
                        <Box
                            sx={{
                                position: 'absolute',
                                top: '40%',
                                left: '50%',
                                transform: 'translate(-50%, -50%)',
                                bgcolor: 'background.paper',
                                boxShadow: 24,
                                p: 4,
                                borderRadius: 2,
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                textAlign: 'center',
                                width: { xs: '90%', sm: '600px' }, // Responsividade
                            }}
                        >
                            <h2 style={{ color: '#333', marginBottom: '20px' }}>Retorno de Documento</h2>
                            <p style={{ textAlign: 'center' }}>
                                Digite aqui quais são as alterações que deverão ser feitas pela empresa:
                            </p>
                            <TextareaAutosize
                                minRows={4}
                                placeholder="Digite suas observações aqui..."
                                value={observacao}
                                onChange={(e: any) => setObservacao(e.target.value)}
                                style={{
                                    width: '100%',
                                    padding: '10px',
                                    borderRadius: '4px',
                                    border: '1px solid #ccc',
                                    marginTop: '10px',
                                    resize: 'vertical',
                                }}
                            />
                            <Button
                                variant="contained"
                                color="primary"
                                style={{ marginTop: '20px', background: '#0d6efd', color: '#fff' }}
                                onClick={() => {
                                    handleReturnDocumento()
                                }}
                            >
                                Retornar Documento
                            </Button>
                        </Box>
                    </Modal>
                    <AlertMessage
                        show={alert.show}
                        message={alert.message}
                        variant={alert.variant}
                        onClose={() => setAlert({ ...alert, show: false })}
                    />
                </CardContent>
            {/* )} */}
        </div>
    );
}
